import { render, staticRenderFns } from "./help05.vue?vue&type=template&id=a696fe30&"
import script from "./help05.vue?vue&type=script&lang=js&"
export * from "./help05.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports